import React, { useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import HoverBadge from "../../shared/HoverBadge";
import { MdAttachFile, MdCached, MdCameraAlt, MdCameraswitch, MdOutlineWatchLater } from "react-icons/md";
import Webcam from "react-webcam";
import { BsCheckLg } from "react-icons/bs";
import Api from "../../../services/ApiService";

const UploadStage = ({ data, setData, setStage, setApiError }) => {

    const API = new Api();
    const [showCamera, setShowCamera] = useState(false);
    const cameraRef = useRef(null);
    const [hasTakenPhoto, setHasTakenPhoto] = useState(false);
    const [showcaseImage, setShowCaseImage] = useState("");
    const [uploadLaterCheck, setUploadLaterCheck] = useState(false);
    const [video, setVideo] = useState({
        width: 720,
        height: 1280
    });

    const switchCameraHanlder = () => {
        let var_video = {};
        if (video.facingMode === "environment") {
            var_video = {
                width: 1280,
                height: 720,
                facingMode: { exact: "environment"}
            };
            var_video.facingMode = "user";
        
        } else {
            var_video = {
                width: 720,
                height: 1280,
                facingMode: { exact: "environment"}
            };
            var_video.facingMode = "environment";
        }
        setVideo(var_video);
    }

    const takePhotoHandler = () => {
        setShowCaseImage(cameraRef.current.getScreenshot());
        var testImage = new Image();
        testImage.onload = () => {
            console.log(testImage.height);
            console.log(testImage.width);
        }
        testImage.src = cameraRef.current.getScreenshot();
        
        setHasTakenPhoto(true);
    }

    const deletePhotoHandler = () => {
        setShowCaseImage("");
        setHasTakenPhoto(false);
    }

    const photoApprovedHandler = () => {
        var fileName = "";
        for (let i = 1; i < 21; i++) {
            fileName = `Bild-${i}`;
            var index = data.uploads.findIndex(i => i.file_name === fileName);
            if (index === -1) break;
        }
        setData(prev => ({...prev, 
            uploads: [...prev.uploads, {file_name: fileName, file: showcaseImage.split(",")[1]}]
        }));
        setShowCaseImage("");
        setHasTakenPhoto(false);
        setShowCamera(false);
    }

    const selectLocalFile = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var tempList = data.uploads;
            var index = tempList.findIndex(i => i.file_name === file.name);
            if (index === -1) tempList.push({file_name: file.name, file: reader.result.split(",")[1]});
            setData(prev => ({...prev, uploads: tempList}));
        }
    }

    const removeFileFromUploads = (fileName) => {
        var tempList = data.uploads.filter(file => file.file_name !== fileName);
        setData(prev => ({...prev, uploads: tempList}));
    }

    const sendData = () => {
        if (uploadLaterCheck) {
            return uploadMissing(); 
        }
        setStage("loading");
        var ticketData = {
            company_type: data.company_type,
            x_is_house_management: data.x_is_house_management,
            case: data.case,
            companyKw: data.companyKw,
            contactPerson: data.contactPerson,
            name: data.name + ` ${data.lastName}`,
            email: data.email,
            phone_country: "+43",
            vorwahl: "",
            phone: `${data.phone_country} ${data.vorwahl} ${data.phone}`,
            comment: data.comment,
            situation: data.situation,
            uploads: data.uploads,
        }
        if (data.upload_later !== undefined && data.upload_later !== "") {
            ticketData.upload_later = data.upload_later
        }
        API.register_bigcompany_contact(ticketData)
            .then(() => {
                setStage("ticket_done");
            })
            .catch(err => {
                setStage("error");
            });
    }

    const uploadMissing = () => {
        setStage("loading");
        var ticketData = {
            company_type: data.company_type,
            x_is_house_management: data.x_is_house_management,
            case: data.case,
            companyKw: data.companyKw,
            contactPerson: data.contactPerson,
            name: data.name,
            lastName: data.lastName,
            email: data.email,
            phone_country: "+43",
            vorwahl: "",
            phone: `${data.phone_country} ${data.vorwahl} ${data.phone}`,
            comment: data.comment,
            situation: data.situation,
        }
        API.register_missing_document(ticketData)
            .then(() => {
                setStage("upload_missing");
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
            });
    }

    return (
        <>
            <div className="text-start mt-5" hidden={showCamera}>
                <h5>Ihre aktuellste Jahresabrechnung</h5>
                <p className="text-dark" style={{ fontSize: 14, fontWeight: 800 }}>
                    Bitte laden Ihre aktuellste Jahresabrechnung hoch, oder verwenden
                    Sie die Kamera, um uns die Seiten der Jahresabrechnung zukommen
                    zu lassen. Stellen Sie bitte sicher, dass Sie <span className="text-light">ALLE Seiten</span> der
                    Jahresabrechnung erfassen!
                </p>

                {data.uploads && data.uploads.length > 0 ?
                    <Row>
                        <Col xs="12">
                            {data.uploads.map(f => (
                                <small>
                                    <HoverBadge
                                        key={`badge-${f.file_name}`}
                                        id={f.file_name}
                                        desc={f.file_name}
                                        remove={() => removeFileFromUploads(f.file_name)}
                                    />
                                </small>
                            ))}
                        </Col>
                    </Row>
                    : null}

                <Row className="mt-4">
                    <Col>
                        <Form.Check 
                            hidden={data.upload_later !== undefined}
                            label="Ich werde meine Jahresabrechnung 
                            später übermitteln. Bitte erinnern Sie mich per E-Mail daran."
                            value={uploadLaterCheck}
                            onChange={e => setUploadLaterCheck(e.target.checked)}
                        />
                    </Col>
                </Row>

                <Row className="mt-4 align-items-center" hidden={uploadLaterCheck}>
                    <Col xs="12" md="6" xl="6">
                        <input
                            type="file"
                            name="attachment"
                            id="attachment"
                            hidden
                            onChange={e => selectLocalFile(e.target.files[0])}
                        />
                        <a
                            onClick={e => { e.preventDefault(); document.getElementById('attachment').click() }}
                            href="anhängen/"
                            className="link-energo text-light"
                            style={{marginRight: 15}}
                        >
                            <MdAttachFile size={25} /> Datei hochladen
                        </a>
                    </Col>
                    <Col xs="12" md="6" xl="6">
                        <Button onClick={() => setShowCamera(!showCamera)} variant="warning">Kamera</Button>
                    </Col>
                </Row>

                <Row className="text-end mt-5">
                    <Col>
                        <Button onClick={() => sendData()} variant="warning">Absenden</Button>
                    </Col>
                </Row>
            </div>
            {showCamera === true?
                <>
                    <Row>
                        <Col xs="12">
                            <div className="wrapper" hidden={hasTakenPhoto}>
                                <Webcam
                                    ref={cameraRef}
                                    width="100%"
                                    videoConstraints={video}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-3" style={{zIndex: 3}}>
                        <Col xs="12" className="text-center">
                            <Button
                                hidden={hasTakenPhoto}
                                onClick={() => switchCameraHanlder()}
                                variant="warning"
                                size="lg"
                                style={{marginRight: 20}}
                            >
                                <MdCameraswitch />
                            </Button>
                            <Button
                                hidden={hasTakenPhoto}
                                size="lg"
                                onClick={() => takePhotoHandler()}
                            >
                                <MdCameraAlt />
                            </Button>
                            <Button
                                variant="danger"
                                hidden={!hasTakenPhoto}
                                onClick={() => deletePhotoHandler()}
                                size="sm"
                            >
                                <MdCached /> Erneut versuchen
                            </Button> &nbsp;
                            <Button
                                hidden={!hasTakenPhoto}
                                onClick={() => photoApprovedHandler()}
                                size="sm"
                            >
                                <BsCheckLg /> Ich bin zufrieden
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col className="text-center">
                            <img src={showcaseImage} alt=""/>
                        </Col>
                    </Row>
                </>
            :null}
        </>
    )
}
export default UploadStage;